export default __webpack_public_path__ + "assets/657f4d18db71816db8df2f2ddd573101.png";